import {React, useCallback, useState} from 'react'
import './pages.css'
import './portfolio.css'
import * as AiIcons from 'react-icons/ai'
import * as RiIcons from 'react-icons/ri'
import * as BsIcons from 'react-icons/bs'
import * as FaIcons from 'react-icons/fa'
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';

import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const Portfolio = () => {

    const particlesInit = useCallback(async (engine) => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async (container) => {
        await console.log(container);
    }, []);

    const [isShown, setIsShown] = useState(false);
    const [content, setContent] = useState({});
    const [techs, setTechs] = useState([]);
    const [open, setOpen] = useState(false);
    const handleOpen = value => () => {
      setOpen(true);
      setContent(value);
      setTechs(value.tech);

    };
    const handleClose = () => setOpen(false);
    
    const projects = [
      {
        title: "MovieBuddy",
        description: "Movie Tracking Tool",
        body: "Users can browse movies, sort by different criteria (rating, release date, etc) and view trailers",
        imgSrc: require('../components/assets/images/MovieBuddy.PNG'),
        tech: ["Angular", "TypeScript", "HTML5", "CSS3" ],
        github: "https://github.com/altaafackbar/MovieBuddy",
        website: "https://moviebuddyapp.netlify.app/"
      },
      {
        title: "ARCHE ECHO",
        description: "Child Health Application",
        body: "A cross platform mobile application to help parents learn about and identify potential illnesses afflicting their children. Fully equipped with emergency services calling, health center map, interactive symptom checker, and much more.",
        imgSrc: require('../components/assets/images/ARCHE.PNG'),
        tech: ["React Native", "JavaScript", "Firebase" ],
        github: "https://github.com/UAlberta-CMPUT401/arche-echo",
        website: "https://expo.dev/@clubsand/arche-echo"
      },
      {
        title: "BookTracker",
        description: "Book Sharing Platform",
        body: "Provides users with a book sharing and borrowing ecosytem. Users can request books from other users, and set exchange locations using a map all inside the app.",
        imgSrc: require('../components/assets/images/BookTracker.jpeg'),
        tech: ["Android Studio", "Java","JavaScript", "XML", "Firebase" ],
        github: "https://github.com/CMPUT301F20T37/booktracker",
        website: ""
      }
    ]
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '50vw',
      height: '50vh',
      bgcolor: '#150d5d',
      //border: '2px solid #000',
      boxShadow: 24,
      p: 4,
      borderRadius: '15px',
      display: 'flex',
      justifyContent: 'center'
    };

    return (
      <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'flex-start', alignItems: 'center', height: '90vh', backgroundColor: '#040c33', zIndex: 10, marginTop: '15vh' }}>
        <div class="fade-in-text1">
                <h1 className='header' style={{fontSize: '2rem'}}>Portfolio</h1>
                <p className='sub' style={{fontSize: '1rem'}}>Check out my recent work</p>


            </div>



            <div className="fade-in-text1">


              <div className='projectContainer'>

                {
                  projects.map((project, index) => {
                    return(
                      <div className='project'
                      onMouseEnter={() => setIsShown(true)}
                      onMouseLeave={() => setIsShown(false)}>
                        <h1 className='title'>{project.title}</h1>
                            <img class='projImg' src={project.imgSrc} />
                        <div className='overlay'>

                              <div className='load'>
                                  <BsIcons.BsFillInfoCircleFill size ={50} onClick={handleOpen(project)}/>
                              </div>

                        </div>
                      </div>
                    )
                  })
                }
                        <Modal
                          aria-labelledby="transition-modal-title"
                          aria-describedby="transition-modal-description"
                          open={open}
                          onClose={handleClose}
                          closeAfterTransition
                          BackdropComponent={Backdrop}
                          BackdropProps={{
                            timeout: 500,
                          }}
                          style={{overflowY: 'scroll', height: '100%', width: '100%'}}
                          
                        >
                          
                          <Fade in={open} >
                            <Box className='box'>
                              <div className='projectDetails'>
                                <h1 className='title'>{content.title}</h1>
                                <div className='info'>
                                  <img class='detailProjImg' src={content.imgSrc} />
                                  <div class="fade-in-text3">
                                      <p className='projectSub'>{content.description}</p>
                                      <p className='projectSub' style={{fontSize: '1rem'}}>{content.body}</p>                                      <div className='techStack'>
                                        {
                                          techs.map((tech, index) => {
                                            return(
                                              
                                                <p className='tech'>{tech}</p>
                                              
                                            )
                                          })
                                        }
                                      </div>
                                      <div className='buttonContent'>
                                        {content.website != "" &&

                                            <a href= {content.website} target="_blank">
                                            <button type="button" class='bouncySmall'>
                                                  <h3 style={{fontSize: '15px', textDecoration: 'none'}}>
                                                        Live Website
                                                    </h3>
                                              

                                            </button>
                                            </a>
                                        }
                                          <a href={content.github} target="_blank"
                                          style={{marginLeft: '10px'}}>
                                              <div className='icon'>
                                                  <BsIcons.BsGithub size ={50} />
                                              </div>
                                          </a>

                                      </div>


                                  </div>
                                  
                                </div>

                                
                            
                              </div>
                            </Box>
                          </Fade>
                        </Modal>
                        
              </div>
             <p className='sub' style={{fontSize: '1rem'}}>More coming soon!</p>

            </div>


             
            
        <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                background: {
                    color: {
                        value: "#040c33",
                    },
                },
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        push: {
                            quantity: 4,
                        },
                        repulse: {
                            distance: 100,
                            duration: 0.4,
                        },
                    },
                },
                particles: {
                    color: {
                        value: "#ffffff",
                    },
                    links: {
                        color: "#714d97",
                        distance: 150,
                        enable: true,
                        opacity: 0.5,
                        width: 1,
                    },
                    collisions: {
                        enable: false,
                    },
                    move: {
                        directions: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 2,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 5 },
                    },
                },
                detectRetina: true,
            }}
        />
        </div>
    )
}

export default Portfolio